export const determineInitTabIndex = (tabs = [], tabName = '') => {
  const index = tabs.findIndex(({ title }) => title === tabName);

  if (index !== -1) return index;
  return 0;
};
